import { RootState } from '../../root-store';
import { CommunicationsState } from './communications';
import { DocumentsListState } from './documents-list/documents-list-types';
import { OfferingDocumentsState } from './offerings/offerings-types';

export interface DocumentsState {
  documentsList: DocumentsListState;
  offerings: OfferingDocumentsState;
  communications: CommunicationsState;
}

export const selectDocumentsState = (state: RootState): DocumentsState =>
  state.features.documents;
